import PropTypes from 'prop-types';
import React from 'react';
/*
"tacticValue": {
    "CANDLE_PATTERN":{
        "BREAK_LOW": {"priceToBreak":99.95},
        "BREAK_HIGH":{"priceToBreak":103.05}},
        "breakBy":0.05,
        "patterns":[
            [
                {"candleSequence":"BREAK_LOW","terminateOnFail":false,"restartOnFail":false,"currentSequence":true},
                {"candleSequence":"BREAK_HIGH","terminateOnFail":false,"restartOnFail":true,"currentSequence":false}
            ],
            [
                {"candleSequence":"OUTSIDE_CANDLE","terminateOnFail":false,"restartOnFail":false,"currentSequence":false},
                {"candleSequence":"INSIDE_CANDLE","terminateOnFail":false,"restartOnFail":true,"currentSequence":false},
                {"candleSequence":"BREAK_HIGH","terminateOnFail":false,"restartOnFail":true,"currentSequence":true}
            ]
        ]
    }
 	}
once again, this message can probably use some refactoring as well. Appreciate the patience... we will talk this one (and flag) more in depth when you get here...

BREAK_HIGH: {priceToBreak: 1}
BREAK_LOW: {priceToBreak: 1}
OUTSIDE_CANDLE: {priceToBreak (high): 1, priceToBreak (low): 1}
BREAK_CANDLE: {priceToBreak (high): 1, priceToBreak (low): 1}
INSIDE_CANDLE: {priceToBreak (high): 1, priceToBreak (low): 1}
FAIL_TO_BREAK_HIGH: {priceToBreak: 1}
FAIL_TO_BREAK_LOW: {priceToBreak: 1}
//
*/
export const CandlePatternWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'CANDLE_PATTERN',
    category: 'Setup',
    type: 'Candle Pattern',
    domain: 'Underlying',
  };
  //const breakBy = softOrder.breakBy; not being used yet, but is being sent up
  return <Component details={details} candlePattern={softOrder} {...rest}/>;
};

CandlePatternWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    CANDLE_PATTERN: PropTypes.object
  })
};

